<template>
  <apexchart id="order" height="300" type="donut" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
export default {
  name: "UserOrdersInfo",
  props: {
    item: {
      type: Object,
      required: true
    },
    series: {
      type: Array,
      default: ()=> {}
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          // events: {
          //   dataPointSelection: (event, chartContext, config) => {
          //     console.log(config.w.config.labels[config.dataPointIndex])
          //   }
          // },
          type: 'pie',
          fontFamily: "IRANSans, sans-serif",
        },
        title: {
          show: true,
          text: this.$store.state.roles.some(v => ['admin', 'salemanager'].includes(v)) ? this.item.UserName : 'سفارشات ثبت شده',
          align: 'center'
        },
        dataLabels: {
          enabled: true,
        },
        labels: ['تایید شده', 'آرشیو و منقضی'],
        legend: {
          position: 'top',
          formatter: function (val) {
            return val.toLocaleString()
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString()
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {},
            legend: {
              show: false,
            }
          }
        }]
      },
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>